import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import { normalizeReturnTo } from '../../utils/editorReturn';
import CreditEditor from './CreditEditor';

function NewCredit() {
	const navigate = useNavigate();
	const params = useParams();
	const { id } = params;
	const location = useLocation();
	const [searchParams] = useSearchParams();
	const route = location.pathname;
	const returnTo = normalizeReturnTo(searchParams.get('returnTo'));

	// Extract IDs from route
	const preloadAccountId = route.includes('account') ? id : null;

	const backTo = preloadAccountId ? `/AdminScreen/accounts/account/${preloadAccountId}` : '/AdminScreen/credits';

	return (
		<EntityList>
			<Helmet>
				<title>Nueva Pasividad</title>
			</Helmet>
			<PageHead
				breadcrumb={[
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: 'Pasividades', to: '/AdminScreen/credits' },
					{ label: 'Nueva pasividad' },
				]}
				title='Nueva pasividad'
				subtitle='Completá los datos principales de la pasividad.'
			/>
			<CreditEditor
				mode='create'
				preloadAccountId={preloadAccountId}
				onCancel={() => navigate(returnTo || backTo)}
				onSaved={(savedCreditId) => {
					if (returnTo) {
						const target = new URL(returnTo, window.location.origin);
						target.searchParams.set('creditId', savedCreditId);
						navigate(`${target.pathname}${target.search}`);
						return;
					}
					navigate(`/AdminScreen/credits/credit/${savedCreditId}`);
				}}
				saveLabel='Agregar'
			/>
		</EntityList>
	);
}

export default NewCredit;
